import { render, staticRenderFns } from "./AddDeduction.vue?vue&type=template&id=cf9513de&scoped=true&"
import script from "./AddDeduction.vue?vue&type=script&lang=js&"
export * from "./AddDeduction.vue?vue&type=script&lang=js&"
import style0 from "./AddDeduction.vue?vue&type=style&index=0&id=cf9513de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9513de",
  null
  
)

export default component.exports